import { ELSI_WEBSOCKET_URL } from "../../const/const";

const preparePartNumberToCompare = (partNumber) => {
    return partNumber.trim().replace(/[^\w\s]/gi, '');
};

export const ABSENCE_PRICES_MESSAGE = 'price-absence';

const createCorePricesList = (pricesArray, productId, partNumber, currentPricesList) => {
    const filteredPrices = pricesArray.filter(it => {
        return it.productId === productId && 
            preparePartNumberToCompare(it.productPartNumber) === preparePartNumberToCompare(partNumber);
    });
    
    filteredPrices.forEach(price => {
        const quantityCurrency = readPriceCurrency() === 'USD' ? 'USD' : (price.currency || 'RUB');
        const corePriceIndex = currentPricesList.findIndex(it => (
            it.manufacturer === price.manufacturer && it.distributor === price.distributor && it.packer === price.packer
        ));
        if(corePriceIndex === -1) {
            currentPricesList.push({
                productId: price.productId, // Добавляем productId для фильтрации
                partNumber: price.productPartNumber,
                manufacturer: price.manufacturer,
                distributor: price.distributor,
                packer: price.packer,
                packerId: price.packerId,
                source: price.source,
                sourceId: price.sourceId,
                stockNumber: price.stockNumber,
                currency: quantityCurrency,
                quantities: [
                    {
                        id: price.priceId,
                        minQty: price.minQty,
                        priceValue: price.priceValue,
                        currency: quantityCurrency,
                    },
                ],
            });
        } else {
            currentPricesList[corePriceIndex].currency = quantityCurrency;
            currentPricesList[corePriceIndex].quantities.push({
                id: price.priceId,
                minQty: price.minQty,
                priceValue: price.priceValue,
                currency: quantityCurrency,
            });
        }
    });
    return currentPricesList;
};

const checkConnection = (ws) => {
    return !!ws;
};

const checkWSIsOpenState = (ws) => {
    return ws.readyState === WebSocket.OPEN;
}; 

const PRICE_CURRENCY_KEY = 'elsi_price_currency';

const readPriceCurrency = () => {
    try {
        return localStorage.getItem(PRICE_CURRENCY_KEY) === 'USD' ? 'USD' : 'RUB';
    } catch (e) {
        return 'RUB';
    }
};

const replaceRubleSign = (root) => {
    if (!root) return;
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    let node = walker.nextNode();
    while (node) {
        if (node.nodeValue && node.nodeValue.includes('₽')) {
            node.nodeValue = node.nodeValue.replace(/₽/g, '$');
        }
        node = walker.nextNode();
    }
};

const applyDollarSign = () => {
    if (readPriceCurrency() !== 'USD' || typeof document === 'undefined') return;
    document.querySelectorAll('.product-price, .product-price__cart, .popup').forEach(replaceRubleSign);
};

let dollarSignObserverStarted = false;

const ensureDollarSign = () => {
    applyDollarSign();
    if (dollarSignObserverStarted || typeof MutationObserver === 'undefined' || typeof document === 'undefined') return;
    dollarSignObserverStarted = true;
    const observer = new MutationObserver(() => applyDollarSign());
    const start = () => {
        if (!document.body) return;
        observer.observe(document.body, { childList: true, subtree: true, characterData: true });
    };
    if (document.body) start();
    else document.addEventListener('DOMContentLoaded', start);
};

const sendWSMessage = (ws, productId, partNumber) => {
    const message = {
        event: "/product/price",
        productId: productId,
        productPartNumber: partNumber,
        priceCurrency: readPriceCurrency(),
    };
    ws.send(JSON.stringify(message));  
};

class priceAsyncService {
    coreObservers = [];
    ws = null;
    interval =  null;
    corePrices = [];
    productId = '';
    partNumber = '';
    isAbsence = false;

    constructor (productId, partNumber) {
        this.productId = productId;
        this.partNumber = partNumber;
        this.corePrices = []; // Очищаем старые цены
        this.coreObservers = []; // Очищаем старые observers
        this.isAbsence = false; // Сбрасываем флаг отсутствия
    }
    
    createWSConnection() {
        if(!checkConnection(this.ws)) {
            const token = localStorage.getItem('token');
            const tokenQuery = token && token !== 'null' && token !== 'undefined'
                ? `?token=${encodeURIComponent(token)}`
                : '';
            this.ws = new WebSocket(`${ELSI_WEBSOCKET_URL}/ws/v1${tokenQuery}`);
            this.ws.onopen = () => {
                const sendPrices = () => sendWSMessage(this.ws, this.productId, this.partNumber);
                if (localStorage.getItem(PRICE_CURRENCY_KEY)) {
                    sendPrices();
                    return;
                }
                const startedAt = Date.now();
                const timer = setInterval(() => {
                    if (localStorage.getItem(PRICE_CURRENCY_KEY) || Date.now() - startedAt > 2000) {
                        clearInterval(timer);
                        if (this.ws && this.ws.readyState === WebSocket.OPEN) {
                            sendPrices();
                        }
                    }
                }, 100);
                // const uuidv4 = 'c8cdf813-3fab-414c-a845-96b1466c1d6e';  
                // this.interval = setInterval(function() {
                //     if(this.ws && this.ws.readyState !== WebSocket.CLOSED) {
                //         this.ws.send(JSON.stringify({
                //             event: "ping",
                //             connectionId: uuidv4,
                //         }));   
                //     }  else {
                //         clearInterval(this.interval);
                //     }
                // }, 1000);
            };
        } else {
            checkWSIsOpenState(this.ws)&&sendWSMessage(this.ws, this.productId, this.partNumber);
        }
        this.ws.onmessage = e => {
            try {
                const message = JSON.parse(e.data);
                this.corePrices = createCorePricesList(message, this.productId, this.partNumber, this.corePrices);
                this.notifyPriceObservers();
            } catch (error) {
                if(e.data === ABSENCE_PRICES_MESSAGE) {
                    this.isAbsence = true;
                    this.notifyPriceObservers();
                } else {
                    console.error(`❌ Parse error for ${this.productId}:`, error);
                }
            }
        };
        
        this.ws.onerror = (error) => {
            console.error(`❌ WebSocket error for ${this.productId}:`, error);
        };
    }

    getPrices() {
        return this.corePrices;
    }

    registerPriceObserver(func) {
        this.coreObservers.push(func);
    }

    unRegisterPriceObserver(func) {
        try {
            this.coreObservers = this.coreObservers.filter(fn => fn !== func);
        } catch(err) {
            console.log(err);
        }
    }

    cleanObservers() {
        this.coreObservers = [];
    }

    notifyPriceObservers() {
        this.coreObservers.map(func => this.isAbsence ? func(ABSENCE_PRICES_MESSAGE) : func(this.getPrices()));
        ensureDollarSign();
    }
};

let priceAsyncServiceItem = new priceAsyncService();

export const handleCreateNewPriceAsyncService = (productId, partNumber) => {
    if(priceAsyncServiceItem.productId !== productId || priceAsyncServiceItem.partNumber !== partNumber) {
        // НЕ очищаем observers! Позволяем multiple observers работать параллельно
        // Закрываем старое соединение только если оно есть
        if (priceAsyncServiceItem && priceAsyncServiceItem.ws && priceAsyncServiceItem.ws.readyState === WebSocket.OPEN) {
            priceAsyncServiceItem.ws.close();
        }
        
        // Переносим существующих observers в новый сервис
        const existingObservers = priceAsyncServiceItem ? [...priceAsyncServiceItem.coreObservers] : [];
        
        priceAsyncServiceItem = new priceAsyncService(productId, partNumber);
        // Восстанавливаем observers
        priceAsyncServiceItem.coreObservers = existingObservers;
        
        priceAsyncServiceItem.createWSConnection();
    }
};

export const registerObserver = (func) => {
    priceAsyncServiceItem.registerPriceObserver(func);
};

export const unRegisterObserver = (func) => {
    priceAsyncServiceItem.unRegisterPriceObserver(func);
};

export const clearPricesAsyncService = () => {
    priceAsyncServiceItem = new priceAsyncService();
};

ensureDollarSign();